import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import MediaApi from '@tekion/tekion-base/services/MediaRepository';
export var fetchMediaList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formData) {
    var mediaData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return MediaApi.getMediaUrls(formData);
        case 2:
          mediaData = _context.sent;
          return _context.abrupt("return", _castArray(_get(mediaData, 'data', EMPTY_ARRAY)));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchMediaList(_x) {
    return _ref.apply(this, arguments);
  };
}();